import React, { useState, useEffect } from 'react';
import { flushSync } from "react-dom";
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody, Spinner, CardHeader, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Select, { components } from 'react-select';
import { FaChevronRight, FaChevronLeft, FaTrash, FaPlus, FaUpload, FaSave } from 'react-icons/fa';
import toast, { Toaster } from 'react-hot-toast';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import axios from 'axios';
import uuid from 'react-uuid';
import CouncilAndLandInfo from '../Enterprises/CouncilAndLandInfo';
import Contacts from '../Enterprises/Contacts';
import StockNumbers from '../Enterprises/StockNumbers';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";
import { convertToRaw, EditorState, convertFromHTML, ContentState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import './Enterprise.css';
import useLocalStorage from "../Utilities/Hooks/useLocalStorage";
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const Enterprises = ({ handleWizardChanged, handleWizardChangedBack, handleMoveToNextPage, refreshToken }) => {
    const [isNextButtonVisible, setIsNextButtonVisible] = useState(false);
    const isAddEditItem = localStorage.getItem("isAddEditItem");
    const [roleName, setRoleName] = useState(localStorage.getItem("roleName"));
    const [farmRoleName, setFarmRoleName] = useLocalStorage('farmRoleName', null);
    const [enterprisesList, setEnterprisesList] = useState([]); const [savingEnterprises, setSavingEnterprises] = useState('');
    const [loading, setLoading] = useState(true);
    const [supplyCompany, setSupplyCompany] = useState(0);
    const [uniqueIdentifier, setUniqueIdentifier] = useState('');
    const [supplyCompanyAccess, setSupplyCompanyAccess] = useState(0);
    const [ruralProfessionalOrganisation, setRuralProfessionalOrganisation] = useState(0);
    const [ruralProfessional, setRuralProfessional] = useState('');
    const [ruralProfessionalAccess, setRuralProfessionalAccess] = useState(0);
    const [farmId, setFarmId] = useState(localStorage.getItem("defaultFarmId"));
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [optionalPages_Effluent, setOptionalPages_Effluent] = useState(false);
    const [optionalPages_Biosecurity, setOptionalPages_Biosecurity] = useState(false);
    const [optionalPages_ContaminantSelfEvaluation, setOptionalPages_ContaminantSelfEvaluation] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const [optionalPages_FreshwaterIrrigation, setOptionalPages_FreshwaterIrrigation] = useState(false);
    const [optionalPages_WinterGrazing, setOptionalPages_WinterGrazing] = useState(false);
    const [optionalPages_Cropping, setOptionalPages_Cropping] = useState(false);
    const [optionalPages_Biodiversity, setOptionalPages_Biodiversity] = useState(false);
    const [optionalPages_GreenhouseGass, setOptionalPages_GreenhouseGass] = useState(false);
    const [farmSystemType, setFarmSystemType] = useState('');
    //const [farmingActivities, setFarmingActivities] = useState('');
    //const [totalArea, setTotalArea] = useState('');
    //const [leaseArea, setLeaseArea] = useState('');
    //const [irrigatedArea, setIrrigatedArea] = useState('');
    //const [savingAssociations, setSavingAssociations] = useState(false);
    const [savingEnterprisesOptions, setSavingEnterprisesOptions] = useState(false);
    //const [savingFarmSystem, setSavingFarmSystem] = useState(false);
    const [savingFarmStory, setSavingFarmStory] = useState(false);
    //const [enterpriseTypeList, setEnterpriseTypeList] = useState([]);
    //const [enterpriseCategoryList, setEnterpriseCategoryList] = useState([]);
    //const [enterpriseTypeListSelectedValues, setEnterpriseTypeListSelectedValues] = useState([]);
    const [enterpriseTypeSelectedValues, setEnterpriseTypeSelectedValues] = useState('');
    const [enterprises, setEnterprises] = useState({ Section: 'Enterprises', SectionName: 'Property Detail', isWizardCompleted: false });
    const [propertyDetails, setPropertyDetails] = useState({
        Name: '', Address1: '', Address2: '', Address3: '', Address4: '', City: '', Country: '', IsPropertyLeased: false, IsPropertyLeasedText: '', FarmLocation: '', nzBusinessNumber: '', infdpUniqueFreshwaterFarmPlanId: '', ExecutiveSummaryComment: '', ParentOrganisationName: '', PostCode: ''
        , LeasedName: '', LeasedAddress1: '', LeasedAddress2: '', LeasedCity: '', LeasedPhone: '', LeasedEmail:''
    });
    const [savingPropertyDetails, setSavingPropertyDetails] = useState(false); const [savingEnterpriseDetails, setSavingEnterpriseDetails] = useState(false); const [savingNext, setSavingNext] = useState(false);
    const [farmStory, setFarmStory] = useState({ FarmStory: '', FarmStoryGoals: '', IntrestingFeatures: '', Concerns: '' });
    const [enterpriseOptions, setEnterpriseOptions] = useState({ FarmingActivities: '', IsAnyMeatCompany: false })
    const [tellUsAbout, setTellUsAbout] = useState({ RiparianAreas: '', AreasRetired: '', FencingOfWaterways: '', StockPolicy: '', Other: '' });
    const [savingTellUsAbout, setSavingTellUsAbout] = useState(false);
    const [isHaveresponsible, setIsHaveresponsible] = useState(false);
    const [isHaveDeveloper, setIsHaveDeveloper] = useState(false);
    const [isHaveContact, setIsHaveContact] = useState(false);
    const [regulatoryRequirementDetails, setRegulatoryRequirementDetails] = useState({ RegulatoryRequirementDetails: '', FWFPToMeetAnyOtherRegulatoryRequirement: 'Yes', INFDPID: 0, IsAnyNewPhsyicalWorks: 'No', AnyNewPhsyicalWorksDetails: '' });
    const [savingRegulatoryRequirementDetails, setSavingRegulatoryRequirementDetails] = useState(false);
    //const [enterpriseRows, setEnterpriseRows] = useState([]);
    //const [enterpriseDetails, setEnterpriseDetails] = useState({ IsPastorallanduse: false, MeatCompanyList: [], IsAnyMeatCompany: 'No', selectedCompanies: [] });
    const [regulatoryRequirementsRows, setRegulatoryRequirementsRows] = useState([]);
    const [enterpriseRowCount, setEnterpriseRowCount] = useState(0);
    const [regulatoryRequirementsRowCount, setRegulatoryRequirementsRowCount] = useState(0);
    const [formErrors, setFormErrors] = useState([]);
    const [uploadType, setUploadType] = useState('NewPhsyicalWork');
    const [documentUploadList, setDocumentUploadList] = useState([]);
    //const [deleteDocumentPopup, setDeleteDocumentPopup] = useState({ showDeleteDocumentPopup: false, itemId: 0, date: '', daetails: '', fileName: '' });
    let inputFile = [];
    const [editorStateFarmStory, setEditorStateFarmStory] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateFarmDescription, setEditorStateFarmDescription] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateFarmingActivities, setEditorStateFarmingActivities] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateFarmStoryGoals, setEditorStateFarmStoryGoals] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateIntrestingFeatures, setEditorStateIntrestingFeatures] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateConcerns, setEditorStateConcerns] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateRiparianAreas, setEditorStateRiparianAreas] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateAreasRetired, setEditorStateAreasRetired] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateFencingOfWaterways, setEditorStateFencingOfWaterways] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateStockPolicy, setEditorStateStockPolicy] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));
    const [editorStateOther, setEditorStateOther] = useState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(''))));

    const [imageFile, setImageFile] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [imageName, setImageName] = useState('');
    const [imagePhysicalFilename, setImagePhysicalFilename] = useState('');
    const [imagePhysicalFilepath, setImagePhysicalFilepath] = useState('');
    const [isEditorEmpty, setIsEditorEmpty] = useState(false);
    const [contactsChanged, setContactsChanged] = useState(false);
    const [councilLandChanged, setCouncilLandChanged] = useState(false);
    const [tellUsAboutChanged, setTellUsAboutChanged] = useState(false);
    const [regulatoryReqChanged, setRegulatoryReqChanged] = useState(false);
    const [vineyardStoryChanged, setVineyardStoryChanged] = useState(false);
    const [vineyardDetailsChanged, setVineyardDetailsChanged] = useState(false);
    const [enterpriseOptionsChanged, setEnterpriseOptionsChanged] = useState(false);
    const [catchment, setCatchment] = useState("");
    const [council, setCouncil] = useState("");
    const [legalTitle, setLegalTitle] = useState("");
    
    const [councilAndLandInfo, setCouncilAndLandInfo] = useState({ RegionalCouncil: 0, AdvisorId: 0, ValuationReference: '', LandParcels: '', OtherRelevantIdentifier: '', ResponsiblePerson: '', Catchment: 0, TotalPropertySize: null, PlantedGrapeArea:null });
    const [councilAndLandRows, setCouncilAndLandRows] = useState([]); const [contactRows, setContactRows] = useState([]);

    const handleEnterpriseSave = async (e, from) => {
        e.preventDefault()

        setIsEditorEmpty(false);
        if (from == '') {
            setSavingEnterpriseDetails(true);
        }
        else if (from == 'Next') {

            setSavingNext(true);
        }
        await saveFarmDetails(e);
        if (contactsChanged) {
            await handleContactRowsSubmit(e);
        }
        if (regulatoryReqChanged) {
            await handleRegulatoryRequirementDetailsSubmit(e);
        }
        if (councilLandChanged) {
            await handleCouncilAndLandRowsSubmit(e);
        }
        toast.success("Property Detail Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
        if (from == '') {
            setSavingEnterpriseDetails(false);
            refreshToken();
        }
        else if (from == 'Next') {
            setSavingNext(false);
        }
    };

    const handleCouncilAndLandRowsSubmit = async (e) => {
        e.preventDefault()
        let tempCouncilAndLandRows = [...councilAndLandRows];
        let form = {
            FarmId: farmId,
            FarmCouncilLandInfos: [],
            UserId: userId,
            RegionalCouncil: councilAndLandInfo.RegionalCouncil,
            CatchmentId: councilAndLandInfo.Catchment,
            AdvisorId: councilAndLandInfo.AdvisorId,
            ValuationReference: councilAndLandInfo.ValuationReference,
            LandParcels: councilAndLandInfo.LandParcels,
            OtherRelevantIdentifier: councilAndLandInfo.OtherRelevantIdentifier,
            ResponsiblePerson: councilAndLandInfo.ResponsiblePerson,
            TotalPropertySize: councilAndLandInfo.TotalPropertySize,
            PlantedGrapeArea: councilAndLandInfo.PlantedGrapeArea
        }
        for (var i = 0; i < tempCouncilAndLandRows.length; i++) {
            var obj = {};
            obj.Id = tempCouncilAndLandRows[i].id;
            obj.FarmId = farmId;
            obj.ConsentType = tempCouncilAndLandRows[i].consentType;
            obj.ConsentNumber = tempCouncilAndLandRows[i].consentNumber;
            obj.RequiredForFEP = tempCouncilAndLandRows[i].requiredForFEP;
            obj.ConsentConditions = tempCouncilAndLandRows[i].consentConditions;
            obj.ExpiryDateText = tempCouncilAndLandRows[i].expiryDate != null ? tempCouncilAndLandRows[i].expiryDateText : "";
            obj.DocumentName = tempCouncilAndLandRows[i].documentName;
            obj.DocumentPhysicalName = tempCouncilAndLandRows[i].documentPhysicalName;
            obj.DocumentPath = tempCouncilAndLandRows[i].documentPath;
            form.FarmCouncilLandInfos.push(obj);
        }

        const response = await apiPost(
            '/api/enterprises/SaveCouncilAndLandInfo/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {

            }
        }
    };

    const handleContactRowsSubmit = async (e) => {
        e.preventDefault()
        //setSavingContacts(true);
        let tempContactRows = [...contactRows];
        let form = {
            FarmId: farmId,
            FarmContacts: [],
            UserId: userId
        }
        for (var i = 0; i < tempContactRows.length; i++) {
            var obj = {};
            obj.Id = tempContactRows[i].id;
            obj.FarmId = farmId;
            obj.Email = tempContactRows[i].email;
            obj.Name = tempContactRows[i].name;
            obj.Role = tempContactRows[i].role;
            obj.Address1 = tempContactRows[i].address1;
            obj.Address2 = tempContactRows[i].address2;
            obj.City = tempContactRows[i].city;
            obj.Phone = tempContactRows[i].phone;
            obj.NZBN = tempContactRows[i].nzbn;
            obj.isResponsible = tempContactRows[i].isResponsible;
            obj.isDeveloper = tempContactRows[i].isDeveloper;
            form.FarmContacts.push(obj);
        }
        const response = await apiPost(
            '/api/enterprises/SaveFarmContacts/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                //toast.success("Contacts Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                //setSavingContacts(false);
                setContactRows(response.data.content);
                await checkAlreadyIsresponsibleChecked();
            }
        }
    };

    useEffect(() => {
        setLoading(true);
        populateItemData();
    }, []);
    const handleCatchmentChange = (newCatchment) => {
        setCatchment(newCatchment);
    };
    const handleCouncilChange = (newCouncil) => {
        setCouncil(newCouncil);
    };

    const handleLegalTitleChange = (newTitle) => {
        setLegalTitle(newTitle);
        
    };

    const Option = (props) => {
        return (
            <div>
                <components.Option {...props}>
                    <input
                        type="checkbox"
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </components.Option>
            </div>
        );
    };
    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/enterprises/getenterprisedetails/', {
                params: { Id: farmId }
            }
            );
            setEnterprisesList(response.data.content);
            flushSync(() => {
                setEnterprisesList(response.data.content);
            });
            setSupplyCompany(response.data.content.enterprises.supplyCompany);
            setSupplyCompanyAccess(response.data.content.enterprises.supplycompanyAccess);
            setUniqueIdentifier(response.data.content.enterprises.uniqueIdentifier);
            setRuralProfessionalOrganisation(response.data.content.enterprises.ruralProfessionalOrganisation);
            setRuralProfessional(response.data.content.enterprises.ruralProfessional);
            setRuralProfessionalAccess(response.data.content.enterprises.ruralProfessionalAccess);
            setOptionalPages_Effluent(response.data.content.enterprises.optionalPages_Effluent);
            setOptionalPages_Biosecurity(response.data.content.enterprises.optionalPages_Biosecurity);
            setOptionalPages_FreshwaterIrrigation(response.data.content.enterprises.optionalPages_FreshwaterIrrigation);
            setOptionalPages_WinterGrazing(response.data.content.enterprises.optionalPages_WinterGrazing);
            setOptionalPages_Cropping(response.data.content.enterprises.optionalPages_Cropping);
            setOptionalPages_Biodiversity(response.data.content.enterprises.optionalPages_Biodiversity);
            setOptionalPages_GreenhouseGass(response.data.content.enterprises.optionalPages_GreenhouseGass);
            setOptionalPages_ContaminantSelfEvaluation(response.data.content.enterprises.optionalPages_ContaminantSelfEvaluation);
            setShow_HistoricalActions(response.data.content.enterprises.show_HistoricalActions);
            setShow_SectionComment(response.data.content.enterprises.show_SectionComment);
            //setFarmSystemType(response.data.content.enterprises.farmSystemType);
            //setFarmingActivities(response.data.content.enterprises.farmingActivities);
            setTellUsAbout(response.data.content.enterprises.tellUsAbout);
            //setEnterpriseTypeList(response.data.content.enterpriseTypes);
            //setEnterpriseCategoryList(response.data.content.enterpriseCategoryList);
            setEnterprises({ ...enterprises, isWizardCompleted: response.data.content.isFWFPCompleted })
            //setTotalArea(response.data.content.totalArea);
            //setLeaseArea(response.data.content.leaseArea);
            //setIrrigatedArea(response.data.content.irrigatedArea);
            setPropertyDetails({
                ...propertyDetails, Name: response.data.content.enterprises.name, Address1: response.data.content.enterprises.address1, Address2: response.data.content.enterprises.address2,
                Address3: response.data.content.enterprises.address3, Address4: response.data.content.enterprises.address4, PostCode: response.data.content.enterprises.postCode, Country: response.data.content.enterprises.country,
                IsPropertyLeased: response.data.content.enterprises.isPropertyLeased, FarmLocation: response.data.content.enterprises.farmLocation,
                nzBusinessNumber: response.data.content.enterprises.nzBusinessNumber, infdpUniqueFreshwaterFarmPlanId: response.data.content.enterprises.infdpUniqueFreshwaterFarmPlanId,
                ExecutiveSummaryComment: response.data.content.enterprises.executiveSummaryComment, ParentOrganisationName: response.data.content.enterprises.parentOrganisationName,
                LeasedName: response.data.content.enterprises.leasedName,
                LeasedAddress1: response.data.content.enterprises.leasedAddress1,
                LeasedAddress2: response.data.content.enterprises.leasedAddress2,
                LeasedCity: response.data.content.enterprises.leasedCity,
                LeasedPhone: response.data.content.enterprises.leasedPhone,
                LeasedEmail: response.data.content.enterprises.leasedEmail,
                IsPropertyLeasedText: response.data.content.enterprises.isPropertyLeased == true ? 'Yes' : (response.data.content.enterprises.isPropertyLeased == false ? 'No' : '')
            });
            const contentFarmStory = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmStory == null ? '' : response.data.content.enterprises.farmStory))
            setEditorStateFarmStory(EditorState.createWithContent(contentFarmStory));

            const contentFarmDescription = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmDescription == null ? '' : response.data.content.enterprises.farmDescription))
            setEditorStateFarmDescription(EditorState.createWithContent(contentFarmDescription));

            const contentFarmingActivities = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmingActivities == null ? '' : response.data.content.enterprises.farmingActivities))
            setEditorStateFarmingActivities(EditorState.createWithContent(contentFarmingActivities));

            const contentFarmStoryGoals = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.farmStoryGoals == null ? '' : response.data.content.enterprises.farmStoryGoals))
            setEditorStateFarmStoryGoals(EditorState.createWithContent(contentFarmStoryGoals));

            const contentIntrestingFeatures = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.intrestingFeatures == null ? '' : response.data.content.enterprises.intrestingFeatures))
            setEditorStateIntrestingFeatures(EditorState.createWithContent(contentIntrestingFeatures));

            const contentConcerns = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.concerns == null ? '' : response.data.content.enterprises.concerns))
            setEditorStateConcerns(EditorState.createWithContent(contentConcerns));

            const contentRiparianAreas = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.riparianAreas == null ? '' : response.data.content.enterprises.riparianAreas))
            setEditorStateRiparianAreas(EditorState.createWithContent(contentRiparianAreas));

            const contentAreasRetired = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.areasRetired == null ? '' : response.data.content.enterprises.areasRetired))
            setEditorStateAreasRetired(EditorState.createWithContent(contentAreasRetired));

            const contentFencingOfWaterways = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.fencingOfWaterways == null ? '' : response.data.content.enterprises.fencingOfWaterways))
            setEditorStateFencingOfWaterways(EditorState.createWithContent(contentFencingOfWaterways));

            const contentStockPolicy = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.stockPolicy == null ? '' : response.data.content.enterprises.stockPolicy))
            setEditorStateStockPolicy(EditorState.createWithContent(contentStockPolicy));

            const contentOther = ContentState.createFromBlockArray(convertFromHTML(response.data.content.enterprises.other == null ? '' : response.data.content.enterprises.other))
            setEditorStateOther(EditorState.createWithContent(contentOther));

            setFarmStory({
                ...farmStory, FarmDescription: response.data.content.enterprises.farmDescription, FarmStory: response.data.content.enterprises.farmStory, FarmStoryGoals: response.data.content.enterprises.farmStoryGoals
                , IntrestingFeatures: response.data.content.enterprises.intrestingFeatures, Concerns: response.data.content.enterprises.concerns
            });
            setTellUsAbout({
                ...tellUsAbout, RiparianAreas: response.data.content.enterprises.riparianAreas, AreasRetired: response.data.content.enterprises.areasRetired
                , FencingOfWaterways: response.data.content.enterprises.fencingOfWaterways, StockPolicy: response.data.content.enterprises.stockPolicy, Other: response.data.content.enterprises.other
            });
            setRegulatoryRequirementDetails({
                ...regulatoryRequirementDetails, FWFPToMeetAnyOtherRegulatoryRequirement: response.data.content.enterprises.fwfpToMeetAnyOtherRegulatoryRequirement,
                INFDPID: response.data.content.enterprises.infdpUniqueFreshwaterFarmPlanId,
                RegulatoryRequirementDetails: response.data.content.enterprises.regulatoryRequirementDetails, IsAnyNewPhsyicalWorks: response.data.content.enterprises.isAnyNewPhsyicalWorks,
                AnyNewPhsyicalWorksDetails: response.data.content.enterprises.anyNewPhsyicalWorksDetails
            })
            setEnterpriseOptions({
                FarmingActivities: response.data.content.enterprises.farmingActivities,
                IsAnyMeatCompany: response.data.content.enterprises.isAnyMeatCompany
            });
            //var activityStr = removeHtmlTags(response.data.content.enterprises.farmingActivities).trim();
            //if (activityStr == '' || activityStr == null || activityStr == undefined) {
            //    setIsEditorEmpty(true);
            //} else {
            setIsEditorEmpty(false);
            setLegalTitle("-1");
            
            
            //}
            

            //setEnterpriseRows(response.data.content.farmEnterprises);

            var enterprisesValue = response.data.content.enterprises;
            //Selected enterprise Type
            let selectedMeatCompanies = []

            if (enterprisesValue.selectedMeatCompaniesList != "" && enterprisesValue.selectedMeatCompaniesList != null) {
                let selectedMeatCompaniesArray = [];

                selectedMeatCompaniesArray = enterprisesValue.selectedMeatCompaniesList.split(',');

                response.data.content.meatCompanyList.map(type => {
                    if (selectedMeatCompaniesArray.includes(String(type.value))) {
                        selectedMeatCompanies.push({
                            value: type.value,
                            label: type.label
                        })
                    }
                })
            }

            //setEnterpriseDetails({ IsPastorallanduse: enterprisesValue.isPastorallanduse, MeatCompanyList: response.data.content.meatCompanyList, IsAnyMeatCompany: enterprisesValue.isAnyMeatCompany, selectedCompanies: selectedMeatCompanies })
            setRegulatoryRequirementsRows(response.data.content.regulatoryRequirements);
            if (response.data.content.farmEnterprises.length > 0) {
                setEnterpriseRowCount(response.data.content.farmEnterprises.length);
            }
            checkAlreadyIsresponsibleChecked();
            getUploadedDocuments();
            if (response.data.content.section != null) {
                var section = window.wizardDetails.filter(x => x.controllerName == response.data.content.section.routePath);
                if (section.length > 0 != null) {
                    setIsNextButtonVisible(section[0].isSectionCompleted);
                }
            }
            //if (response.data.content.enterprises.Catchment == null) {
            //    setIsNextButtonVisible(false);
            //}
            //else {
            //    setIsNextButtonVisible(true);
            //}
            if (response.data.content.enterprises.propertyImageName != null) {
                setImageName(response.data.content.enterprises.propertyImageName);
                setImagePhysicalFilename(response.data.content.enterprises.propertyImagePhysicalName);
                setImagePhysicalFilepath(response.data.content.enterprises.propertyImagePath);
                setImagePreviewUrl(response.data.content.enterprises.propertyImageRelativePath);
            }
            else {
                setImageName(null);
                setImagePhysicalFilename(null);
                setImagePhysicalFilepath(null);
                setImagePreviewUrl(null);
            }

            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
            setLoading(false);
        }
    }
    function removeHtmlTags(str) {
        return str.replace(/<\/?[^>]+(>|$)/g, ""); 
    }
    const handleRegulatoryRequirementRowsAddRow = () => {
        const item = {
            regulatoryRequirement: "",
            condition: "", id: 0
        };
        setRegulatoryRequirementsRows([...regulatoryRequirementsRows, item]);
        setRegulatoryReqChanged(true);
    };

    const handleRegulatoryRequirementRowsRemoveSpecificRow = (idx) => () => {
        setRegulatoryReqChanged(true);
        const tempRows = [...regulatoryRequirementsRows]
        tempRows.splice(idx, 1)
        setRegulatoryRequirementsRows(tempRows);
    }

    const checkAlreadyIsresponsibleChecked = async () => {
        let alreadyChecked = false;
        let checkedDeveloper = false;
        let checkedContacts = false;
        try {
            const response = await apiGet(
                '/api/enterprises/GetContacts/', {
                params: { Id: farmId }
            }
            );
            if (response.data.content.farmContacts.length > 0) {
                checkedContacts = true;
            }
            for (var i = 0; i < response.data.content.farmContacts.length; i++) {
                if (response.data.content.farmContacts[i].isResponsible == true) {
                    alreadyChecked = true;
                }
            }
            for (var i = 0; i < response.data.content.farmContacts.length; i++) {
                if (response.data.content.farmContacts[i].isDeveloper == true) {
                    checkedDeveloper = true;
                }
            }
            setIsHaveresponsible(alreadyChecked);
            setIsHaveDeveloper(checkedDeveloper);
            setIsHaveContact(checkedContacts);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    const getUploadedDocuments = async () => {
        try {
            const response = await apiGet(
                '/api/upload/GetUploadedDocuments/', {
                params: { Id: farmId, UploadType: uploadType, FarmId: farmId }
            }
            );
            if (response.data.status) {
                setDocumentUploadList(response.data.content);
                let tempErrors = [];
                response.data.content.forEach(function (element) {
                    const error = {
                        fileError: ''
                    };
                    tempErrors.push(error);
                });
                setFormErrors(tempErrors);
            }

        } catch (err) {
            console.log(err);
        }
    }

    const handleRegulatoryRequirementChange = idx => e => {
        setRegulatoryReqChanged(true);
        const tempRows = [...regulatoryRequirementsRows];
        tempRows[idx].regulatoryRequirement = e.target.value;
        setRegulatoryRequirementsRows(tempRows);
    };

    const handleRegulatoryRequirementConditionChange = idx => e => {
        setRegulatoryReqChanged(true);
        const tempRows = [...regulatoryRequirementsRows];
        tempRows[idx].condition = e.target.value;
        setRegulatoryRequirementsRows(tempRows);
    };

    

    const handleFarmStorySubmit = async (e) => {
        e.preventDefault()
        setSavingFarmStory(true);
        saveFarmDetails();
    };
    const handleEnterpriseOptionsSubmit = async (e) => {

        e.preventDefault()
        setSavingEnterprisesOptions(true);
        saveFarmDetails();
    };

    

    const handlePropertyDetailsSubmit = async (e) => {
        e.preventDefault()
        setSavingPropertyDetails(true);
        saveFarmDetails();
    };



    const handleRegulatoryRequirementDetailsSubmit = async (e) => {
        e.preventDefault()
        setSavingRegulatoryRequirementDetails(true);

        let tempRegulatoryRequirementsRows = [...regulatoryRequirementsRows];
        if (regulatoryRequirementDetails.IsAnyNewPhsyicalWorks == "No") {
            regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails = "";
        }
        let form = {
            FarmId: farmId,
            RegulatoryRequirements: [],
            UserId: userId,
            FWFPToMeetAnyOtherRegulatoryRequirement: regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement,
            INFDPUniqueFreshwaterFarmPlanId: regulatoryRequirementDetails.INFDPID,
            IsAnyNewPhsyicalWorks: regulatoryRequirementDetails.IsAnyNewPhsyicalWorks,
            AnyNewPhsyicalWorksDetails: regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails
        }
        for (var i = 0; i < tempRegulatoryRequirementsRows.length; i++) {
            var obj = {};
            obj.Id = tempRegulatoryRequirementsRows[i].id;
            obj.RegulatoryRequirement = tempRegulatoryRequirementsRows[i].regulatoryRequirement;
            obj.Condition = tempRegulatoryRequirementsRows[i].condition;
            form.RegulatoryRequirements.push(obj);
        }
        const response = await apiPost(
            '/api/enterprises/SaveRegulatoryRequirements/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                //handleRecordRowsSubmit();
                //toast.success("Other Regulatory Requirements Saved!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                //setSavingRegulatoryRequirementDetails(false);
                //setRegulatoryRequirementsRows(response.data.content);
            }
        }

    };

    const handleTellUsAboutSubmit = async (e) => {
        e.preventDefault()
        setSavingTellUsAbout(true);
        saveFarmDetails();
    };

    

    const saveFarmDetails = async () => {
        //var noStockOnThisFarm = document.getElementById("noStockOnThisFarm").checked;

        let form = {
            Id: farmId,
            UniqueIdentifier: uniqueIdentifier,
            SupplyCompany: supplyCompany,
            SupplycompanyAccess: supplyCompanyAccess,
            RuralProfessionalOrganisation: ruralProfessionalOrganisation,
            RuralProfessional: ruralProfessional,
            RuralProfessionalAccess: ruralProfessionalAccess,
            OptionalPages_Effluent: optionalPages_Effluent,
            OptionalPages_FreshwaterIrrigation: optionalPages_FreshwaterIrrigation,
            OptionalPages_WinterGrazing: optionalPages_WinterGrazing,
            OptionalPages_Cropping: optionalPages_Cropping,
            OptionalPages_Biodiversity: optionalPages_Biodiversity,
            OptionalPages_GreenhouseGass: optionalPages_GreenhouseGass,
            OptionalPages_Biosecurity: optionalPages_Biosecurity,
            OptionalPages_ContaminantSelfEvaluation: optionalPages_ContaminantSelfEvaluation,
            Show_HistoricalActions: show_HistoricalActions,
            Show_SectionComment: show_SectionComment,
            FarmSystemType: farmSystemType,
            //FarmingActivities: farmingActivities,
            //IsNoStockOnThisFarm: noStockOnThisFarm,
            FarmingActivities: draftToHtml(convertToRaw(editorStateFarmingActivities.getCurrentContent())),
            IsAnyMeatCompany: enterpriseOptions.IsAnyMeatCompany,
            Enterprises: enterpriseTypeSelectedValues.toString(),
            UserId: userId,
            Address1: propertyDetails.Address1,
            Address2: propertyDetails.Address2,
            Address3: propertyDetails.Address3,
            City: propertyDetails.City,
            Country: propertyDetails.Country,
            IsPropertyLeased: propertyDetails.IsPropertyLeased,
            LeasedName: propertyDetails.LeasedName,
            LeasedAddress1: propertyDetails.LeasedAddress1,
            LeasedAddress2: propertyDetails.LeasedAddress2,
            LeasedCity: propertyDetails.LeasedCity,
            LeasedPhone: propertyDetails.LeasedPhone,
            LeasedEmail: propertyDetails.LeasedEmail,
            ExecutiveSummaryComment: propertyDetails.ExecutiveSummaryComment,
            Address4: propertyDetails.Address4,
            FarmLocation: propertyDetails.FarmLocation,
            FarmStory: draftToHtml(convertToRaw(editorStateFarmStory.getCurrentContent())),
            FarmStoryGoals: draftToHtml(convertToRaw(editorStateFarmStoryGoals.getCurrentContent())), //farmStory.FarmStoryGoals,
            FarmDescription: draftToHtml(convertToRaw(editorStateFarmDescription.getCurrentContent())), //farmStory.FarmDescription,
            IntrestingFeatures: draftToHtml(convertToRaw(editorStateIntrestingFeatures.getCurrentContent())), //farmStory.IntrestingFeatures,
            Concerns: draftToHtml(convertToRaw(editorStateConcerns.getCurrentContent())), //farmStory.Concerns,
            RiparianAreas: draftToHtml(convertToRaw(editorStateRiparianAreas.getCurrentContent())), //tellUsAbout.RiparianAreas,
            AreasRetired: draftToHtml(convertToRaw(editorStateAreasRetired.getCurrentContent())), //tellUsAbout.AreasRetired,
            FencingOfWaterways: draftToHtml(convertToRaw(editorStateFencingOfWaterways.getCurrentContent())), //tellUsAbout.FencingOfWaterways,
            StockPolicy: draftToHtml(convertToRaw(editorStateStockPolicy.getCurrentContent())), //tellUsAbout.StockPolicy,
            Other: draftToHtml(convertToRaw(editorStateOther.getCurrentContent())), //tellUsAbout.Other,
            RegulatoryRequirementDetails: regulatoryRequirementDetails.RegulatoryRequirementDetails,
            NZBusinessNumber: propertyDetails.nzBusinessNumber,
            INFDPUniqueFreshwaterFarmPlanId: propertyDetails.infdpUniqueFreshwaterFarmPlanId,
            PropertyImageName: imageName,
            PropertyImagePhysicalName: imagePhysicalFilename,
            PropertyImagePath: imagePhysicalFilepath,

        }

        const response = await apiPost(
            '/api/enterprises/Save/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {

            }
        }
    }

    const noIsresponsibleError = () => {
        const contentState = editorStateFarmingActivities.getCurrentContent();
        const isEmpty = !contentState.hasText();
        const stateStr = councilAndLandInfo.LandParcels;
        var errstr = [];
        console.log()
        
        if (!isHaveContact) {
            errstr.push("Add at least 1 contact");
        }
        if (!isHaveresponsible ) {
            errstr.push("Indicate who is the Farm Operator");
        }
        if (!isHaveDeveloper ) {
            errstr.push("Indicate who is the Freshwater Farm Plan Developer");
        }
        if (!council || council == "-1") {
            errstr.push("Select Regional Council");
            setCouncil("");
        }

        if (!catchment ||  catchment=="-1") {
            errstr.push("Select Catchment");
            setCatchment("");
        }
        if (isEmpty) {
            errstr.push("Describe the Activities around the Wine Growing enterprise on this vineyard");
            setIsEditorEmpty(true);
        }
        if (!stateStr) {
            setLegalTitle("");
            errstr.push("Include legal title")
        }
        if (enterpriseOptions.IsAnyMeatCompany == undefined || enterpriseOptions.IsAnyMeatCompany == null || enterpriseOptions.IsAnyMeatCompany == '') {
            errstr.push("Select does this vineyard graze sheep")
        }
        if (errstr.length > 0) {
            toast.error(
                (t) => (
                    <div>
                        <span>Please complete mandatory fields before continuing:</span>
                        <br />
                        <ul>
                            {errstr.map((error, index) => (
                                <li key={index}>{error}</li>
                            ))}
                        </ul>
                        <button className="toast-close-button"
                            onClick={() => toast.dismiss(t.id)}
                        >
                            OK
                        </button>
                    </div>
                ),
                {
                    duration: Infinity, style: { border: '1px solid #f76054', padding: '16*/px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', }
                }
            );
        }
    }

    const handleRecordRowsAddRow = () => {
        const item = {
            createdDate: getParsedDate1(new Date()),
            documentDetail: "", id: 0, documentName: '', documentPhysicalName: '', documentPath: '', documentRelativePath: ''
        };
        const error = {
            fileError: ''
        };
        setFormErrors([...formErrors, error]);
        setDocumentUploadList([...documentUploadList, item]);
    };

    const handleRecordRowsRemoveSpecificRow = (idx) => () => {
        const tempRows = [...documentUploadList]
        const tempErrors = [...formErrors];
        tempRows.splice(idx, 1)
        tempErrors.splice(idx, 1)
        setDocumentUploadList(tempRows);
        setFormErrors(tempErrors);
    }

    const handleDateChange = (idx, date) => {
        const tempRows = [...documentUploadList];
        tempRows[idx].uploadDateText = getParsedDate(date);
        tempRows[idx].uploadDate = getDateFromString(getParsedDate(date));
        setDocumentUploadList(tempRows);
    };

    const getParsedDate1 = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "/" + mm + "/" + yyyy;
        return date.toString();
    }

    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }

    const handleDetailsChange = idx => e => {
        const tempRows = [...documentUploadList];
        tempRows[idx].documentDetail = e.target.value;
        setDocumentUploadList(tempRows);
    };

    const handleRecordChange = async (e, idx) => {
        e.preventDefault();
        const tempErrors = [...formErrors];
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'application/pdf') {
            errors.fileError = "Only Pdf files can upload!";
            tempErrors[idx].fileError = "Only Pdf files can upload!";
        }
        else {
            tempErrors[idx].fileError = "";
        }
        setFormErrors(tempErrors);
        if (Object.keys(errors).length == 0) {
            if (file.type == 'application/pdf') {
                const formData = new FormData();
                formData.append("FarmId", farmId);
                formData.append("ReferenceId", farmId);
                formData.append("Type", uploadType);
                formData.append("FileName", e.target.files[0].name);
                formData.append("File", e.target.files[0]);
                formData.append("userId", userId);

                const response = await apiPost(
                    '/api/uploaddocument/UploadDocument/', formData,
                    {
                        headers: { "Content-type": "multipart/form-data", "FarmId": farmId, "ReferenceId": farmId, "Type": uploadType, "userId": userId, "FileName": e.target.files[0].name },
                        withCredentials: true
                    });
                if (response.data != null) {
                    if (response.data.status) {
                        const tempRows = [...documentUploadList];
                        tempRows[idx].documentName = response.data.content.DocumentName;
                        tempRows[idx].documentPhysicalName = response.data.content.DocumentPhysicalName;
                        tempRows[idx].documentPath = response.data.content.DocumentPath;
                        tempRows[idx].documentRelativePath = response.data.content.RelativeFilepath;
                        setDocumentUploadList(tempRows);
                    }
                }

                //fetch('api/uploaddocument/UploadDocument', {
                //    method: 'POST',
                //    body: formData
                //}).then(r => r.json()).then(res => {
                //    if (res.status) {
                //        const tempRows = [...documentUploadList];
                //        tempRows[idx].documentName = res.content.DocumentName;
                //        tempRows[idx].documentPhysicalName = res.content.DocumentPhysicalName;
                //        tempRows[idx].documentPath = res.content.DocumentPath;
                //        tempRows[idx].documentRelativePath = res.content.RelativeFilepath;
                //        setDocumentUploadList(tempRows);
                //    }
                //});
            }
        }
        else {
            e.target.value = null;
        }
    }

    const handleBtnUploadClick = async (e, idx) => {
        e.preventDefault();
        inputFile[idx].click();
        return false;
    }

    const handleRecordRowsSubmit = async (e) => {

        let tempRecordUploadList = [...documentUploadList];
        let form = {
            ReferenceId: farmId,
            FarmId: farmId,
            UploadType: uploadType,
            userId: userId,
            Documents: []
        }
        for (var i = 0; i < tempRecordUploadList.length; i++) {
            if (tempRecordUploadList[i].documentName != '' && tempRecordUploadList[i].documentName != null && tempRecordUploadList[i].documentName != undefined) {
                var obj = {};
                obj.Id = tempRecordUploadList[i].id;
                obj.documentDetail = tempRecordUploadList[i].documentDetail;
                obj.documentName = tempRecordUploadList[i].documentName;
                obj.documentPhysicalName = tempRecordUploadList[i].documentPhysicalName;
                obj.documentPath = tempRecordUploadList[i].documentPath;
                obj.UploadDateText = tempRecordUploadList[i].uploadDate != null ? tempRecordUploadList[i].uploadDateText : "";
                form.Documents.push(obj);
            }
        }
        const response = await apiPost(
            '/api/upload/SaveDocuments/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                setTimeout(() => {
                    setDocumentUploadList(response.data.content);
                    let tempErrors = [];
                    setFormErrors(tempErrors);
                    response.data.content.forEach(function (element) {
                        const error = {
                            fileError: ''
                        };
                        tempErrors.push(error);
                    });
                    setFormErrors(tempErrors);
                }, 2000);
            }
        }
    };

    //const handleMultMeatCompaniesChange = (e) => {
    //    setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: [] });
    //    let selectedCompany = '';
    //    setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: e });
    //    e.forEach(function (element) {
    //        if (selectedCompany == '') {
    //            selectedCompany = element.value;
    //        }
    //        else {
    //            selectedCompany = selectedCompany + ',' + element.value;
    //        }
    //    });

    //    setEnterpriseDetails({ ...enterpriseDetails, selectedCompanies: selectedCompany });

    //}

    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yes2";
    const showToastMessage = (e, message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    let inputImageFile = ''; const [imageViewPopup, setImageViewPopup] = useState({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    const handleBtnImageUploadClick = async (e) => {
        e.preventDefault();
        inputImageFile.click();
        return false;
    }

    const handleImageViewPopup = (event, imageName, imageUrl) => {
        setImageViewPopup({ showImageViewPopup: true, imageName: imageName, imageUrl: imageUrl });
    }

    const handleImageViewPopupClose = (event) => {
        setImageViewPopup({ showImageViewPopup: false, imageName: '', imageUrl: '' });
    }

    const handleImageChange = async (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];

        getBase64(file)
            .then(result => {
                let form = {
                    FileName: file.name.replace(/\.[^/.]+$/, ""),
                    Type: "Property",
                    Base64Image: result, FarmId: farmId
                }
                const response = apiPost(
                    '/api/upload/UploadImage/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    }).then(res => {
                        if (res.data != null) {
                            if (res.data.status) {
                                setImagePreviewUrl(res.data.content.RelativeFilepath);
                                setImagePhysicalFilename(res.data.content.PhysicalFilename);
                                setImagePhysicalFilepath(res.data.content.PhysicalFilepath);
                            }
                        }
                    });
            })
            .catch(err => {
                console.log(err);
            });

        reader.onloadend = () => {
            setImageName(file.name);
            setImageFile(file);
            setImagePreviewUrl(reader.result);
        }

        reader.readAsDataURL(file)
    }

    const getBase64 = async (file) => {
        return new Promise(resolve => {
            let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result;
                resolve(baseURL);
            };
        });
    };

    const handleWizardChangedWrapper = async (e, Section) => {
        
        if (checkMandatoryFields()) {
            await handleEnterpriseSave(e, 'Next');
            handleWizardChanged(Section);
        }
        else {
            noIsresponsibleError();
        }
    };
    const handleMoveToNextPageWrapper = async (e, Section) => {
        //await handleEnterpriseSave(e, 'Next');
        handleMoveToNextPage(Section);
    };
    const handleEditorChange = (state) => {
        setEditorStateFarmingActivities(state);
        const contentState = state.getCurrentContent();
        if (contentState.hasText()) {
            setIsEditorEmpty(false); // Reset the error state
        }
    };
    const checkMandatoryFields = () => {
        const contentState = editorStateFarmingActivities.getCurrentContent();
        const isEmpty = !contentState.hasText();
        const stateStr = councilAndLandInfo.LandParcels;
        
        if (isHaveresponsible == true && isHaveDeveloper == true && catchment && catchment != "-1" && council && council != "-1" && !isEmpty && stateStr
            && (enterpriseOptions.IsAnyMeatCompany != undefined && enterpriseOptions.IsAnyMeatCompany != null && enterpriseOptions.IsAnyMeatCompany != '')
        ) {
            return true;
        } else {
            return false;
        }
    }
    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Row>
                <Col><h3 className="header3">{enterprises.SectionName}</h3></Col>
                {enterprises.isWizardCompleted != true && !loading &&
                    <Col>
                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                            <>
                                
                                {(checkMandatoryFields()) ?
                                    <>
                                        {savingNext ?
                                            <Button className="float-end btn-next-page" onClick={(e) => handleWizardChangedWrapper(e, enterprises.Section)}
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Processing
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Processing...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button className="float-end btn-next-page" onClick={(e) => handleWizardChangedWrapper(e, enterprises.Section)} >
                                                Next <FaChevronRight />
                                            </Button>
                                        }

                                    </>
                                    :

                                    <Button className="float-end btn-next-page-warning" onClick={noIsresponsibleError}>Next <FaChevronRight /> </Button>
                            }
                            {savingEnterpriseDetails ?
                                <Button className="float-end btn-next-page" onClick={(e) => handleEnterpriseSave(e, '')}
                                    disabled
                                >
                                    <Row>
                                        <Col sm="8">
                                            <span>
                                                {' '}Saving
                                            </span>
                                        </Col>
                                        <Col sm="4">
                                            <Spinner size="sm">
                                                Saving...
                                            </Spinner>
                                        </Col>
                                    </Row>
                                </Button>
                                :
                                <Button className="float-end btn-next-page" onClick={(e) => handleEnterpriseSave(e, '')} >
                                    Save 
                                </Button>
                            }
                            </>
                        }
                        {(roleName != 'SWNZ Admin' && farmRoleName != 'SWNZ Admin' && farmRoleName != 'Manager') && isNextButtonVisible &&
                            <>

                                {(checkMandatoryFields() ) ?

                                    <>
                                        {savingNext ?
                                            <Button className="float-end btn-next-page" onClick={(e) => handleMoveToNextPageWrapper(e, enterprises.Section)}
                                                disabled
                                            >
                                                <Row>
                                                    <Col sm="8">
                                                        <span>
                                                            {' '}Processing
                                                        </span>
                                                    </Col>
                                                    <Col sm="4">
                                                        <Spinner size="sm">
                                                            Processing...
                                                        </Spinner>
                                                    </Col>
                                                </Row>
                                            </Button>
                                            :
                                            <Button className="float-end btn-next-page" onClick={(e) => handleMoveToNextPageWrapper(e, enterprises.Section)} >
                                                Next <FaChevronRight />
                                            </Button>
                                        }

                                    </>
                                    :
                                    <Button className="float-end btn-next-page-warning" onClick={noIsresponsibleError}>Next <FaChevronRight /> </Button>
                                }
                            </>
                        }
                    </Col>
                }
            </Row>
            {loading ? <SpinnerContainer /> : <>
                <Row xs="2">
                    <Col>
                        <Card className="my-4">
                            <CardHeader className="d-flex card-header-dark">
                                <h5>Vineyard Details</h5>
                            </CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Vineyard ID</Label> <br />
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" disabled={true} value={uniqueIdentifier} onChange={(e) => { setUniqueIdentifier(e.target.value); setVineyardDetailsChanged(true) }} name="uniqueIdentifier" id="uniqueIdentifier" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Vineyard Name</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" disabled={true} value={propertyDetails.Name} onChange={(e) => { setPropertyDetails({ ...propertyDetails, Name: e.target.value }); setVineyardDetailsChanged(true); }} name="Name" id="Name" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {propertyDetails.ParentOrganisationName && (
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Label className="label" for="name">Parent organisation Name</Label>
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" disabled={true} value={propertyDetails.ParentOrganisationName} onChange={(e) => { setPropertyDetails({ ...propertyDetails, ParentOrganisationName: e.target.value }); setVineyardDetailsChanged(true); }} name="OrgName" id="OrgName" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                )}

                                <Row style={{ display: "none" }}>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">NZ business number</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" value={propertyDetails.nzBusinessNumber} onChange={(e) => { setPropertyDetails({ ...propertyDetails, nzBusinessNumber: e.target.value }); setVineyardDetailsChanged(true); }} name="nzBusinessNumber" id="nzBusinessNumber" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address 1</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" disabled={true} value={propertyDetails.Address1} onChange={(e) => { setPropertyDetails({ ...propertyDetails, Address1: e.target.value }); setVineyardDetailsChanged(true); }} name="Address1" id="Address1" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address 2</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" disabled={true} value={propertyDetails.Address2} onChange={(e) => { setPropertyDetails({ ...propertyDetails, Address2: e.target.value }); setVineyardDetailsChanged(true); }} name="Address2" id="Address2" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Address 3</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" disabled={true} value={propertyDetails.Address3} onChange={(e) => { setPropertyDetails({ ...propertyDetails, Address3: e.target.value }); setVineyardDetailsChanged(true); }} name="Address3" id="Address3" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">City</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" disabled={true} value={propertyDetails.Address4} onChange={(e) => { setPropertyDetails({ ...propertyDetails, Address4: e.target.value }); setVineyardDetailsChanged(true); }} name="Address4" id="Address4" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Postcode</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="text" disabled={true} value={propertyDetails.PostCode} onChange={(e) => { setPropertyDetails({ ...propertyDetails, PostCode: e.target.value }); setVineyardDetailsChanged(true); }} name="PostCode" id="PostCode" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Is part, or all of this this Property Leased or Licensed?</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            {/*<Input type="checkbox" checked={propertyDetails.IsPropertyLeased} onChange={(e) => { setPropertyDetails({ ...propertyDetails, IsPropertyLeased: e.target.checked }); setVineyardDetailsChanged(true); }} name="IsLeased" id="IsLeased" autoComplete="new-password" />*/}

                                            <Input type="select" value={propertyDetails.IsPropertyLeasedText} onChange={(e) => { setPropertyDetails({ ...propertyDetails, IsPropertyLeasedText: e.target.value, IsPropertyLeased: (e.target.value == '' ? null : (e.target.value == 'Yes' ? true : (e.target.value == 'No' ? false : null))) }); setVineyardDetailsChanged(true); }} name="isPropertyLeasedText" id="isPropertyLeasedText">
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>

                                        </FormGroup>
                                    </Col>
                                </Row>
                                {propertyDetails.IsPropertyLeased &&
                                    <div style={{marginLeft:"15px"}}>
                                        <Row>
                                            <Col>
                                            <label><b>LEASED AREA LANDOWNER / LESSOR</b></label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Label className="label" for="name">Name</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                                <FormGroup>
                                                    <Input type="text" value={propertyDetails.LeasedName} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedName: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedName" id="LeasedName" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                    </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                <Label className="label" for="name">Address 1</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" value={propertyDetails.LeasedAddress1} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedAddress1: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedAddress1" id="LeasedAddress1" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                <Label className="label" for="name">Address 2</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" value={propertyDetails.LeasedAddress2} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedAddress2: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedAddress2" id="LeasedAddress2" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                <Label className="label" for="name">City</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" value={propertyDetails.LeasedCity} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedCity: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedCity" id="LeasedCity" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                <Label className="label" for="name">Phone</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" value={propertyDetails.LeasedPhone} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedPhone: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedPhone" id="LeasedPhone" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="6">
                                                <FormGroup>
                                                <Label className="label" for="name">Email</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col sm="6">
                                            <FormGroup>
                                                <Input type="text" value={propertyDetails.LeasedEmail} onChange={(e) => { setPropertyDetails({ ...propertyDetails, LeasedEmail: e.target.value }); setVineyardDetailsChanged(true); }} name="LeasedEmail" id="LeasedEmail" autoComplete="new-password" />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>    
                                }


                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="d-flex card-header-dark">
                                <h5>Other Regulatory Requirements Covered</h5>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Are you using this Fresh Water Farm plan to meet any other regulatory requirements?</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="select" value={regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement} onChange={(e) => { setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, FWFPToMeetAnyOtherRegulatoryRequirement: e.target.value }); setRegulatoryReqChanged(true); }} name="FWFPToMeetAnyOtherRegulatoryRequirement" id="FWFPToMeetAnyOtherRegulatoryRequirement">
                                                <option value="">Select</option>
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ display: "none" }}>
                                    <Col sm="6">
                                        <FormGroup>
                                            <span className="label-note">Detail any regulatory requirements which this Fresh Water Farm Plan (when certified) will also meet. Examples include Regional Plan Rules, National Environmental Standards, or Regulations made under section 360 of the act</span>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="textarea" value={regulatoryRequirementDetails.RegulatoryRequirementDetails} onChange={(e) => { setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, RegulatoryRequirementDetails: e.target.value }); setRegulatoryReqChanged(true); }} name="RegulatoryRequirementDetails" id="RegulatoryRequirementDetails" autoComplete="new-password" />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {
                                    regulatoryRequirementDetails.FWFPToMeetAnyOtherRegulatoryRequirement == "Yes" && <>
                                        <Row>
                                            <Col>
                                                {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                    <>
                                                        <button onClick={handleRegulatoryRequirementRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                            <FaPlus />
                                                        </button>
                                                    </>
                                                }
                                            </Col>
                                        </Row>
                                        <br />
                                        <Row>
                                            <Col>

                                                <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                    <thead>
                                                        <tr>
                                                            <th className="text-left"> Regulatory Requirement </th>
                                                            <th className="text-left"> Condition </th>
                                                            <th />
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-left">
                                                        {regulatoryRequirementsRows != undefined && regulatoryRequirementsRows.map((item, idx) => (
                                                            <tr id="addr0" key={idx}>
                                                                <td style={{ display: "none" }}>{regulatoryRequirementsRows[idx].id}</td>
                                                                <td style={{ width: "25%" }}>
                                                                    <input className="form-control" type="text" value={regulatoryRequirementsRows[idx].regulatoryRequirement} maxLength="1000" onChange={handleRegulatoryRequirementChange(idx)} name="regulatoryRequirement" id="regulatoryRequirement" autoComplete="new-password" />
                                                                </td>
                                                                <td style={{ width: "25%" }}>
                                                                    <input className="form-control" type="text" value={regulatoryRequirementsRows[idx].condition} maxLength="1000" onChange={handleRegulatoryRequirementConditionChange(idx)} name="condition" id="condition" autoComplete="new-password" />
                                                                </td>
                                                                <td style={{ width: "5%" }}>
                                                                    {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                        <>
                                                                            <button style={{ float: "right" }} onClick={handleRegulatoryRequirementRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                <FaTrash />
                                                                            </button>
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                            </Col>
                                        </Row>
                                    </>
                                }
                                <Row style={{ display: "none" }}>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Label className="label" for="name">Are there any new phsyical works being planned for the farm?</Label>
                                        </FormGroup>
                                    </Col>
                                    <Col sm="6">
                                        <FormGroup>
                                            <Input type="select" value={regulatoryRequirementDetails.IsAnyNewPhsyicalWorks} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, IsAnyNewPhsyicalWorks: e.target.value })} name="IsAnyNewPhsyicalWorks" id="IsAnyNewPhsyicalWorks">
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {
                                    regulatoryRequirementDetails.IsAnyNewPhsyicalWorks == "Yes" && <>
                                        <Row>
                                            <Col>
                                                <span className="label-note"> Please detail below and attach relevant document if needed.</span>
                                                <FormGroup>
                                                    <Input type="textarea" value={regulatoryRequirementDetails.AnyNewPhsyicalWorksDetails} onChange={(e) => setRegulatoryRequirementDetails({ ...regulatoryRequirementDetails, AnyNewPhsyicalWorksDetails: e.target.value })} name="AnyNewPhsyicalWorksDetails" id="AnyNewPhsyicalWorksDetails" />
                                                </FormGroup>

                                                <div>
                                                    <Row>
                                                        <Col>
                                                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                <>
                                                                    <button onClick={handleRecordRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse-light">
                                                                        <FaPlus />
                                                                    </button>
                                                                </>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <br />
                                                    <Row>
                                                        <Col sm="12">
                                                            <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">
                                                                <thead className="text-left">
                                                                    <tr>
                                                                        <th className="text-left"> Date</th>
                                                                        <th className="text-left"> Details </th>
                                                                        <th className="text-left"> Attachment </th>
                                                                        <th />
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="text-left">
                                                                    {documentUploadList.map((item, idx) => (
                                                                        <tr id="records" key={idx}>
                                                                            <td style={{ display: "none" }}>{documentUploadList[idx].id}</td>
                                                                            <td style={{ width: "15%" }}>
                                                                                <DatePicker selected={documentUploadList[idx].uploadDate != null ? getDateFromString(moment(documentUploadList[idx].uploadDate).format("DD/MM/YYYY")) : null} onChange={(date) => handleDateChange(idx, date)} showYearDropdown
                                                                                    dateFormatCalendar="MMMM"
                                                                                    yearDropdownItemNumber={15}
                                                                                    scrollableYearDropdown
                                                                                    fixedHeight name="uploadDate" dateFormat="dd/MM/yyyy" className="form-control" />
                                                                            </td>
                                                                            <td style={{ width: "45%" }}>
                                                                                <input type="textarea" name="documentDetail" value={documentUploadList[idx].documentDetail} onChange={handleDetailsChange(idx)} className="form-control" />
                                                                            </td>
                                                                            <td style={{ width: "15%" }}>
                                                                                {documentUploadList[idx].documentRelativePath != null && documentUploadList[idx].documentRelativePath != '' ?
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <a href={documentUploadList[idx].documentRelativePath} target='_blank'>
                                                                                                <img src="/images/PDF_icon.png" className="PDF_icon" ></img>
                                                                                            </a>
                                                                                        </Col>
                                                                                        <Col>
                                                                                            {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                                                <>
                                                                                                    <Button style={{ float: `right` }} color="warning" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                                </>
                                                                                            }
                                                                                        </Col>
                                                                                    </Row>
                                                                                    :
                                                                                    <>
                                                                                        {(roleName == 'SWNZ Admin' || farmRoleName == 'SWNZ Admin' || farmRoleName == 'Manager') &&
                                                                                            <>
                                                                                                <Button style={{ float: `right` }} color="success" size="sm" onClick={(e) => handleBtnUploadClick(e, idx)} ><FaUpload /></Button>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                                <br />
                                                                                <input style={{ float: `right`, display: 'none' }}
                                                                                    ref={input => {
                                                                                        inputFile[idx] = input;
                                                                                    }}
                                                                                    type="file" name="attachment" className="form-control" onChange={(e) => handleRecordChange(e, idx)} />
                                                                                {formErrors.length > 0 && formErrors[idx] != undefined && formErrors[idx].fileError != undefined &&
                                                                                    <p className="errorMessage">{formErrors[idx].fileError}</p>
                                                                                }
                                                                            </td>
                                                                            <td style={{ width: "5%" }}>
                                                                                <button style={{ float: "right" }} onClick={handleRecordRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">
                                                                                    <FaTrash />
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                        </Col>

                                                    </Row>
                                                </div>
                                            </Col>

                                        </Row>

                                    </>
                                }
                                {/*<Row>*/}
                                {/*    <Col>*/}
                                {/*        {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                                {/*            <>*/}
                                {/*                {savingRegulatoryRequirementDetails ?*/}
                                {/*                    <Button style={{ float: "right" }} onClick={handleRegulatoryRequirementDetailsSubmit}*/}
                                {/*                        color="success"*/}
                                {/*                        disabled*/}
                                {/*                    >*/}
                                {/*                        <Row>*/}
                                {/*                            <Col sm="8">*/}
                                {/*                                <span>*/}
                                {/*                                    {' '}Saving*/}
                                {/*                                </span>*/}
                                {/*                            </Col>*/}
                                {/*                            <Col sm="4">*/}
                                {/*                                <Spinner size="sm">*/}
                                {/*                                    Saving...*/}
                                {/*                                </Spinner>*/}
                                {/*                            </Col>*/}
                                {/*                        </Row>*/}
                                {/*                    </Button>*/}
                                {/*                    :*/}
                                {/*                    <Button style={{ float: "right" }} onClick={handleRegulatoryRequirementDetailsSubmit} color="success" size="sm">*/}
                                {/*                        Save*/}
                                {/*                    </Button>*/}
                                {/*                }*/}
                                {/*            </>*/}
                                {/*        }*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}
                            </CardBody>
                        </Card>
                        <CouncilAndLandInfo setCouncilLandChanged={setCouncilLandChanged} councilAndLandRows={councilAndLandRows} setCouncilAndLandRows={setCouncilAndLandRows} councilAndLandInfo={councilAndLandInfo} setCouncilAndLandInfo={setCouncilAndLandInfo} userId={userId} onCatchmentChange={handleCatchmentChange} onLegalTitleChange={handleLegalTitleChange} legalTitle={legalTitle} isCatchment={catchment} onCouncilChange={handleCouncilChange} isCouncil={council}></CouncilAndLandInfo>


                    </Col>
                    <Col>
                        <Card className="my-4">
                            <CardHeader className="card-header card-header-dark d-flex justify-content-between align-items-center">
                                <h5 >
                                    Enterprises & Options&nbsp;&nbsp;&nbsp;
                                    {/*<img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-22" onClick={(e) => e.stopPropagation()} />*/}
                                </h5>
                                {/*<ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}*/}
                                {/*    id="my-tooltip-22"*/}
                                {/*    place="top"*/}
                                {/*    variant="info"*/}
                                {/*    render={({ content, activeAnchor }) => (*/}
                                {/*        <>*/}
                                {/*            <Row>*/}
                                {/*                <Col>*/}
                                {/*                    <p style={{ fontWeight: "lighter" }}>*/}
                                {/*                        For more information on Enterprise and Farming details <a href="https://freshwaterfarmplan.co.nz/fwfp-support/enterprise-farm-detail/" target="_blank" rel="noreferrer">Click Here</a>*/}
                                {/*                    </p>*/}
                                {/*                </Col>*/}
                                {/*            </Row>*/}
                                {/*        </>*/}
                                {/*    )}*/}
                                {/*/>*/}
                                {/*{(roleName == 'SWNZ Admin' || isAddEditItem == 'true') &&*/}
                                {/*    <>*/}
                                {/*        <button onClick={handleEnterpriseRowsAddRow} type="button" id="btnUpdate" className="btn btn-sm btn-pluse">*/}
                                {/*            <FaPlus />*/}
                                {/*        </button>*/}
                                {/*    </>*/}
                                {/*}*/}
                            </CardHeader>
                            <br />
                            <CardBody>
                                {/*<Row>*/}
                                {/*    <Col>*/}

                                {/*        <table style={{ float: "right", marginTop: "-10px" }} className="table table-bordered table-hover" id="tab_logic">*/}
                                {/*            <thead>*/}
                                {/*                <tr>*/}
                                {/*                    <th className="text-left"> Category (Land Use) </th>*/}
                                {/*                    <th className="text-left"> Enterprise (Land Use sub-category) </th>*/}
                                {/*                    <th className="text-left"> Enterprise Type </th>*/}
                                {/*                    <th className="text-left"> Enterprise / Farming Activities Description </th>*/}
                                {/*                    <th />*/}
                                {/*                </tr>*/}
                                {/*            </thead>*/}
                                {/*            <tbody className="text-left">*/}
                                {/*                {enterpriseRows.map((item, idx) => (*/}
                                {/*                    <tr id="addr0" key={idx}>*/}
                                {/*                        <td style={{ display: "none" }}>{enterpriseRows[idx].id}</td>*/}
                                {/*                        <td style={{ width: "25%" }}>*/}
                                {/*                            {enterpriseCategoryList == undefined && <p><em>Loading...</em></p>}*/}
                                {/*                            {enterpriseCategoryList != undefined && enterpriseCategoryList != null &&*/}
                                {/*                                <Input type="select" value={enterpriseRows[idx].enterpriseCategory} onChange={handleEnterpriseCategoryChange(idx)} name="enterpriseCategory" id="enterpriseCategory">*/}
                                {/*                                    {enterpriseCategoryList.map(items =>*/}
                                {/*                                        <option key={uuid()} value={items.id}>{items.name}</option>*/}
                                {/*                                    )}*/}
                                {/*                                </Input>*/}
                                {/*                            }*/}
                                {/*                        </td>*/}
                                {/*                        <td style={{ width: "25%" }}>*/}
                                {/*                            {enterpriseTypeList == undefined && <p><em>Loading...</em></p>}*/}
                                {/*                            {enterpriseTypeList != undefined && enterpriseTypeList != null &&*/}
                                {/*                                <Input type="select" value={enterpriseRows[idx].enterpriseType} onChange={handleEnterpriseTypeChange(idx)} name="enterpriseType" id="enterpriseType">*/}
                                {/*                                    {enterpriseTypeList.filter(x => x.category == enterpriseRows[idx].enterpriseCategory).map(items =>*/}
                                {/*                                        <option key={uuid()} value={items.id}>{items.name}</option>*/}
                                {/*                                    )}*/}
                                {/*                                </Input>*/}
                                {/*                            }*/}
                                {/*                        </td>*/}
                                {/*                        <td style={{ width: "25%" }}>*/}
                                {/*                            <input className="form-control" type="text" value={enterpriseRows[idx].farmingActivity} maxLength="20" onChange={handleFarmingActivityChange(idx)} name="farmingActivity" id="farmingActivity" autoComplete="new-password" />*/}
                                {/*                        </td>*/}
                                {/*                        <td style={{ width: "45%" }}>*/}
                                {/*                            <textarea name="overviewOfFarmingActivities"*/}
                                {/*                                value={enterpriseRows[idx].overviewOfFarmingActivities}*/}
                                {/*                                onChange={handleOverviewOfFarmingActivitiesChange(idx)}*/}
                                {/*                                className="form-control"></textarea>*/}
                                {/*                        </td>*/}
                                {/*                        <td style={{ width: "5%" }}>*/}
                                {/*                            {(roleName == 'SWNZ Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&*/}
                                {/*                                <>*/}
                                {/*                                    {!enterpriseRows[idx].isLUPresent &&*/}
                                {/*                                        <button style={{ float: "right" }} onClick={handleEnterpriseRowsRemoveSpecificRow(idx)} type="button" id="btnUpdate" className="btn btn-sm btn-danger">*/}
                                {/*                                            <FaTrash />*/}
                                {/*                                        </button>*/}
                                {/*                                    }*/}
                                {/*                                </>*/}
                                {/*                            }*/}
                                {/*                        </td>*/}
                                {/*                    </tr>*/}
                                {/*                ))}*/}
                                {/*            </tbody>*/}
                                {/*        </table>*/}

                                {/*    </Col>*/}
                                {/*</Row>*/}

                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="FarmingActivities">Describe the Activities on the vineyard</Label>
                                        </FormGroup>
                                        <Editor handlePastedText={() => false}
                                            defaultEditorState={editorStateFarmingActivities}
                                            onEditorStateChange={handleEditorChange}
                                            wrapperClassName="wrapper-class"
                                            toolbarClassName="toolbar-class"
                                            editorClassName={`editor-class ${isEditorEmpty ? "invalid-editor" : ""}`}
                                            toolbar={
                                                {
                                                    options: ['inline'], inline: {
                                                        inDropdown: false,
                                                        options: ['bold', 'italic', 'underline'],
                                                    }
                                                }
                                            }
                                        />
                                        {isEditorEmpty && <div className="error-message">* This field is mandatory.</div>}
                                    </Col>
                                    {/*<Col sm="6">*/}
                                    {/*</Col>*/}
                                    {/*<Col sm="6">*/}
                                    {/*    {isEditorEmpty && <div className="error-message">* This field is mandatory.</div>}*/}
                                    {/*</Col>*/}
                                </Row>
                                <br />
                                <Row>
                                    <Col sm="4">
                                        <FormGroup>
                                            <Label className="label" for="IsAnyMeatCompany"><label style={{ color: "red" }}>*</label>Does this vineyard graze sheep?</Label>
                                        </FormGroup>
                                        <Row>
                                            <Col sm="4">
                                                <FormGroup>
                                                    <Input type="select" value={enterpriseOptions.IsAnyMeatCompany} onChange={(e) => { setEnterpriseOptions({ ...enterpriseOptions, IsAnyMeatCompany: e.target.value }); setEnterpriseOptionsChanged(true); }} name="IsAnyMeatCompany" id="IsAnyMeatCompany">
                                                        <option value="">Select</option>
                                                        <option value="Yes">Yes</option>
                                                        <option value="No">No</option>
                                                    </Input>
                                                    {!enterpriseOptions.IsAnyMeatCompany && (
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            * This field is mandatory
                                                        </span>
                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-dark"><h5>Vineyard Story</h5></CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Description</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, FarmStory: e.target.value })} value={farmStory.FarmStory} name="FarmStory" id="FarmStory" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFarmDescription}
                                                onEditorStateChange={setEditorStateFarmDescription}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">History</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, FarmStory: e.target.value })} value={farmStory.FarmStory} name="FarmStory" id="FarmStory" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFarmStory}
                                                onEditorStateChange={setEditorStateFarmStory}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Potential Goals</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, FarmStoryGoals: e.target.value })} value={farmStory.FarmStoryGoals} name="FarmStoryGoals" id="FarmStoryGoals" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFarmStoryGoals}
                                                onEditorStateChange={setEditorStateFarmStoryGoals}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Interesting Features</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, IntrestingFeatures: e.target.value })} value={farmStory.IntrestingFeatures} name="IntrestingFeatures" id="IntrestingFeatures" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateIntrestingFeatures}
                                                onEditorStateChange={setEditorStateIntrestingFeatures}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Is there anything else you would like to state about your property.</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setFarmStory({ ...farmStory, Concerns: e.target.value })} value={farmStory.Concerns} name="Concerns" id="Concerns" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateConcerns}
                                                onEditorStateChange={setEditorStateConcerns}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className="my-4">
                            <CardHeader className="card-header-dark"><h5>Tell us about the work you have already done</h5></CardHeader>
                            <br />
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Riparian areas/Wetlands</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, RiparianAreas: e.target.value })} value={tellUsAbout.RiparianAreas} name="RiparianAreas" id="RiparianAreas" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateRiparianAreas}
                                                onEditorStateChange={setEditorStateRiparianAreas}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Areas that have been retired (QEII)</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, AreasRetired: e.target.value })} value={tellUsAbout.AreasRetired} name="AreasRetired" id="AreasRetired" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateAreasRetired}
                                                onEditorStateChange={setEditorStateAreasRetired}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Fencing of Waterways</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, FencingOfWaterways: e.target.value })} value={tellUsAbout.FencingOfWaterways} name="FencingOfWaterways" id="FencingOfWaterways" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateFencingOfWaterways}
                                                onEditorStateChange={setEditorStateFencingOfWaterways}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Stock Policy (if any)</Label>

                                        </FormGroup>
                                        <FormGroup>
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, StockPolicy: e.target.value })} value={tellUsAbout.StockPolicy} name="StockPolicy" id="StockPolicy" />*/}
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateStockPolicy}
                                                onEditorStateChange={setEditorStateStockPolicy}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12">
                                        <FormGroup>
                                            <Label className="label" for="name">Other</Label>
                                        </FormGroup>
                                        <FormGroup>
                                            <Editor handlePastedText={() => false}
                                                defaultEditorState={editorStateOther}
                                                onEditorStateChange={setEditorStateOther}
                                                wrapperClassName="wrapper-class"
                                                editorClassName="editor-class"
                                                toolbarClassName="toolbar-class"
                                                toolbar={
                                                    {
                                                        options: ['inline'], inline: {
                                                            inDropdown: false,
                                                            options: ['bold', 'italic', 'underline'],
                                                        }
                                                    }
                                                }
                                            />
                                            {/*<Input type="textarea" onChange={(e) => setTellUsAbout({ ...tellUsAbout, Other: e.target.value })} value={tellUsAbout.Other} name="Other" id="Other" />*/}
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Contacts setContactsChanged={setContactsChanged} userId={userId} contactRows={contactRows} setContactRows={setContactRows}></Contacts>
                    </Col>

                </Row>
            </>
            }
            <Modal isOpen={imageViewPopup.showImageViewPopup} size="lg" className="imageViewPopup">
                <ModalHeader toggle={handleImageViewPopupClose} >{imageViewPopup.imageName}</ModalHeader>
                <ModalBody>
                    <img src={imageViewPopup.imageUrl} className="item-image-popup" alt={imageViewPopup.imageName} ></img>
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={handleImageViewPopupClose}>Close</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Enterprises;